import React, { createContext, useContext, useState, useEffect } from 'react';
import log from 'loglevel';
import { useTranslation } from 'react-i18next';
import { usePlayerContext } from '../Context';
import ControlIcon from './ControlIcon';
import { TextButton } from '../../types/player';
import Tooltip from './Tooltip';

const ControlButton = ({
  icon,
  handleAction,
  className,
  title,
}: {
  icon: string;
  className: string;
  handleAction: any;
  title: string;
}) => {
  const { sdk } = usePlayerContext();
  const { t } = useTranslation();
  const openSettings = () => {
    sdk.clickControl(className);
    handleAction();
  };

  let textButton: TextButton =
    sdk.options().getControls().getSettings().textButton ?? TextButton.HIDE;

  return (
    <Tooltip position="top" tooltipText={t(title)} componentName={className}>
      <button
        tabIndex={0}
        onClick={openSettings}
        className={`
          ${sdk.getClassNamePrefix()}-player-control-button 
          ${sdk.getClassNamePrefix()}-player-control-button-${className} 
          ${[TextButton.REPLACE_BUTTON, TextButton.BOTH].includes(textButton) ? sdk.getClassNamePrefix() + '-player-control-button-show-text' : ''}
        `}
        aria-label={t(title)}
      >
        <span
          className={`${sdk.getClassNamePrefix()}-player-control-button-icon`}
        >
          {textButton != TextButton.REPLACE_BUTTON && (
            <ControlIcon iconName={icon} />
          )}
        </span>
        <span
          className={`${sdk.getClassNamePrefix()}-player-control-button-title`}
        >
          {t(title)} <ControlIcon iconName={'chevronRight'} />
        </span>
      </button>
    </Tooltip>
  );
};

export default ControlButton;
